import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { checkUserPermissionsByCategory, CrudService, CrudType, currentComponentPageBasedPermissionsSelector$, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams, RxjsService } from '@app/shared';
import { CollectionModuleApiSuffixModels } from '@modules/collection';
import { COLLECTION_COMPONENT } from '@modules/collection/shared';
import { Store } from '@ngrx/store';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { handleNgrxStoreData, processStoreData } from '@app/shared/utils/combine-page-level.utils';
@Component({
  selector: 'app-bad-debt-suspension-list',
  templateUrl: './bad-debt-suspension-list.component.html'
})
export class BadDebtSuspensionListComponent extends PrimeNgTableVariablesModel implements OnInit {
  listSubscribtion: any;
  constructor(
    private crudService: CrudService,
    private rxjsService: RxjsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>) {
    super()
    this.selectedTabIndex = this.activatedRoute.snapshot.queryParams?.tab ? +this.activatedRoute.snapshot.queryParams?.tab : 0;
    this.primengTableConfigProperties = {
      tableCaption: "Bad Debt Suspension",
      breadCrumbItems: [{ displayName: 'Credit Control', relativeRouterUrl: '' }, { displayName: 'Bad Debt Suspension - Final Demand' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Final Demand',
            dataKey: 'finalDemandRejectionReasonId',
            captionFontSize: '21px',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'division', header: 'Division', width: '150px' },
              // { field: 'branch', header: 'Branch', width: '150px' },
              { field: 'noOfRecords', header: 'Total No Of Records', width: '150px' },
              { field: 'noofFinalDemands', header: 'No Of Final Demands', width: '150px' },
              { field: 'runDate', header: 'Run Date', width: '150px', isDateTime: true },
              // { field: 'startDate', header: 'Start Date', width: '150px', isDate: true },
              // { field: 'endDate', header: 'End Date', width: '150px', isDate: true },
              { field: 'statusName', header: 'Status', width: '150px' },
            ],
            enableAddActionBtn: true,
            isDateWithTimeRequired: true,
            apiSuffixModel: CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_FINAL_DEMAND_TOTAL_LIST,
            moduleName: ModulesBasedApiSuffix.COLLECTIONS,
            disabled: true
          },
          {
            caption: 'Potential Suspension',
            dataKey: 'finalDemandRejectionReasonId',
            captionFontSize: '21px',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'division', header: 'Division', width: '150px' },
              // { field: 'branch', header: 'Branch', width: '150px' },
              { field: 'noOfRecords', header: 'Total No Of Records', width: '150px' },
              { field: 'noofPotentialSuspension', header: 'No Of Potential Suspension', width: '150px' },
              { field: 'runDate', header: 'Run Date', width: '150px', isDateTime: true },
              // { field: 'startDate', header: 'Start Date', width: '150px', isDate: true },
              // { field: 'endDate', header: 'End Date', width: '150px', isDate: true },
              { field: 'statusName', header: 'Status', width: '150px' },
            ],
            enableAddActionBtn: true,
            isDateWithTimeRequired: true,
            apiSuffixModel: CollectionModuleApiSuffixModels.BAD_DEBT_SUSPENSION_POTENTIAL_SUSPENSION_TOTAL_LIST,
            moduleName: ModulesBasedApiSuffix.COLLECTIONS,
            disabled: true
          }
        ]
      }
    }
  }

  ngOnInit(): void {
    handleNgrxStoreData((response) => {
      let processData = processStoreData(response, this.primengTableConfigProperties, COLLECTION_COMPONENT.BAD_DEBT_SUSPENSION);
      this.primengTableConfigProperties = processData.primengTableConfigProperties
      this.loggedInUserData = processData.loggedInUserData
    }, this.store); 
    this.getTableListData();
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }
  getTableListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    let collectionModuleApiSuffixModels: CollectionModuleApiSuffixModels;
    collectionModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    if (this.listSubscribtion && !this.listSubscribtion.closed) {
      this.listSubscribtion.unsubscribe();
    }
    this.listSubscribtion = this.crudService.get(
      this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
      collectionModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe((data: IApplicationResponse) => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.dataList = data.resources;
        this.totalRecords = data.totalCount;
      } else {
        this.dataList = data.resources;
        this.totalRecords = 0;
      }
      this.reset = false;
    })
  }

  onCRUDRequested(type: CrudType | string, row?: object | any, unknownVar?: any): void {
    switch (type) {
      case CrudType.CREATE:
        if (checkUserPermissionsByCategory(this, CrudType.CREATE)) {
          this.openAddEditPage(CrudType.CREATE, row);
        }
        break;
      case CrudType.GET:
        this.row = row ? row : { pageIndex: 0, pageSize: 10 };
        this.first = row?.pageIndex && row?.pageSize ? row["pageIndex"] * row["pageSize"] : 0;
        this.getTableListData(this.row["pageIndex"], this.row["pageSize"], unknownVar)
        break;
      case CrudType.VIEW:
        if (checkUserPermissionsByCategory(this, CrudType.EDIT)) {
          this.openAddEditPage(CrudType.VIEW, row);
        }
        break;
      default:
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string, index?: number): void {
    switch (type) {
      case CrudType.CREATE:
        switch (this.selectedTabIndex) {
          case 0:
            this.router.navigate(['./add-edit'], { relativeTo: this.activatedRoute, queryParams: { tab: this.selectedTabIndex } })
            break;
          case 1:
            this.router.navigate(['./add-edit'], { relativeTo: this.activatedRoute, queryParams: { tab: this.selectedTabIndex } })
            break;
        }
        break;
      case CrudType.VIEW:
        switch (this.selectedTabIndex) {
          case 0:
            this.router.navigate(['./add-edit'], { relativeTo: this.activatedRoute, queryParams: { tab: this.selectedTabIndex, id: editableObject['badDebitSuspensionFinalDemandId'] } })
            break;
          case 1:
            this.router.navigate(['./add-edit'], { relativeTo: this.activatedRoute, queryParams: { tab: this.selectedTabIndex, id: editableObject['badDebitSuspensionPotentialId'] } })
            break;
        }
        break;
    }
  }

  onTabChange(event) {
    this.loading = false;
    this.dataList = [];
    this.totalRecords = null;
    this.selectedTabIndex = event.index;
    this.selectedRows = [];
    this.primengTableConfigProperties.breadCrumbItems[1].displayName = this.primengTableConfigProperties.tableCaption + ' - ' + this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption;
    this.router.navigate(['/collection/bad-debt-suspension'], { queryParams: { tab: this.selectedTabIndex } })
    this.getTableListData();
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }

  ngOnDestroy() {
    if (this.listSubscribtion) {
      this.listSubscribtion.unsubscribe();
    }
  }
}
